import { render } from "./PreviewMessage.vue?vue&type=template&id=408765e2"
import script from "./PreviewMessage.vue?vue&type=script&lang=js"
export * from "./PreviewMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__